import React from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

const AlertDialogBox = ({ show, dialogBoxData, handleClose, handleSubmit }) => {
  const { id, actionType, heading, body, submitBtnName } = dialogBoxData;
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{heading}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: body }} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="danger" onClick={() => handleSubmit(id, actionType)}>
          {submitBtnName}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AlertDialogBox;
